
export function dateStrFormatToString(dateStr, formater) {
  let date = new Date(dateStr);
  formater = formater != null ? formater : "yyyy-MM-dd hh:mm";
  Date.prototype.Format = function (fmt) {
    var o = {
      "M+": this.getMonth() + 1, //月
      "d+": this.getDate(), //日
      "h+": this.getHours(), //小时
      "m+": this.getMinutes(), //分
      "s+": this.getSeconds(), //秒
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度
      S: this.getMilliseconds(), //毫秒
    };

    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (this.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
    }
    return fmt;
  };
  return date.Format(formater);
}
// 根据date 和 天数，
export function dateStringByday(date, dayNum) {
  let end = format(date, 'yyyy-MM-dd');
  let dayTime = date.getTime() - (24 * 60 * 60 * 1000) * dayNum;
  let endDate = new Date(dayTime);
  let start = format(endDate, 'yyyy-MM-dd');
  return [start, end];
}

// 根据date 和 未来天数，
export function dateStringByFutureday(date, dayNum) {
  let start = format(date, 'yyyy-MM-dd');
  let dayTime = date.getTime() + (24 * 60 * 60 * 1000) * dayNum;
  let endDate = new Date(dayTime);
  let end = format(endDate, 'yyyy-MM-dd');
  return [start, end];
}


/**
 * 计算两个日期之间的天数
 * @param dateString1  开始日期 yyyy-MM-dd
 * @param dateString2  结束日期 yyyy-MM-dd
 * @returns {number} 如果日期相同 返回一天 开始日期大于结束日期，返回0
 */
export function getDaysBetween(date1, date2) {
  let startDate = new Date(date1);
  let endDate = new Date(date2);
  if (startDate > endDate) {
    return 0;
  }
  if (startDate == endDate) {
    return 1;
  }
  let days = (endDate - startDate) / (24 * 60 * 60 * 1000) + 1;
  return days;
}


function format(date, fmt) {
  var o = {
    "M+": date.getMonth() + 1, //月
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds(), //毫秒
  };

  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1
          ? o[k]
          : ("00" + o[k]).substr(("" + o[k]).length)
      );
  }
  return fmt;
}

export function compareDate(d1, d2) {
  return new Date(d1.replace(/-/g, "/")).getTime() < new Date(d2.replace(/-/g, "/")).getTime()
}

export function compareDateNotEqual(d1, d2) {
  return new Date(d1.replace(/-/g, "/")).getTime() <= new Date(d2.replace(/-/g, "/")).getTime();
}


export const pickerOptions = {
  disabledDate: (time) => {
    let minTime = new Date('2010-01-01 00:00:00').getTime();
    return time.getTime() > Date.now() || time.getTime() < minTime;
  },
}


export function getOneYearArr() {
  // 设置默认时间为近一年
  const endDate = new Date();
  const startDate = `${endDate.getFullYear()}-01-01`;
  const formatDate = (date) => {
    return date.toISOString().split('T')[0];
  };  
  return [
    startDate,
    formatDate(endDate)
  ];;
}